import { render } from "./Edit.vue?vue&type=template&id=f2810442&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=f2810442&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Nebula PC\\Coding\\web-projects\\snowchron\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2810442"]])

export default __exports__